import React from 'react';
import styled from 'styled-components';

// Same accent as the survey's top ProgressBar. The track is a light translucent strip rather
// than the top bar's dark one so it stays visible on the pulse check's near-black background.
const Track = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background: #ffffff33;
  overflow: hidden;
`

const Fill = styled.div`
  height: 100%;
  border-radius: 5px;
  background: #d2275a;
  transition: width 150ms ease-out;
`

const Caption = styled.div`
  margin-top: 8px;
  font-size: 15px;
  text-align: center;
  color: inherit;
`

// Same red as the survey's *Required validation text
const OverTotal = styled.span`
  color: #ef0c0c;
  font-weight: bold;
`

export default ({
  placed = 0,
  total = 0
}) => {
  const isOverTotal = total > 0 && placed > total
  const pct = total > 0 ? Math.min(100, Math.round((placed / total) * 100)) : 0

  return (
    <div style={{ width: '100%' }}>
      <Track>
        <Fill style={{ width: `${pct}%` }} />
      </Track>
      <Caption>
        <strong>{placed}</strong>{' of '}<strong>{total}</strong>{' students placed · '}
        {
          isOverTotal
            ? <OverTotal>{'> 100%'}</OverTotal>
            : `${pct}%`
        }
      </Caption>
    </div>
  )
}
